var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fill: "#2255a1",
    viewBox: "0 0 432 432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67 144v220c0 7 3 14 8 19 4 4 11 7 18 7h220c8 0 14-3 19-7 5-5 8-12 8-19V144h15v220c0 11-5 22-13 29-7 8-17 12-29 12H93c-11 0-22-4-29-12-8-7-12-18-12-29V144h15z M403 191c3 3 3 8 0 10-3 3-7 3-10 0L210 18c-2-1-5-2-7-2s-5 1-6 3L14 201c-3 3-8 3-11 0-3-2-3-7 0-10L186 8c5-5 11-7 17-7s12 2 17 7l183 183zM203 221c12 0 22 5 29 12 8 8 13 18 13 29v143h-83V262c0-11 4-21 12-29 7-7 18-12 29-12zm0 15c-7 0-14 3-18 8-5 5-8 11-8 18v128h53V262c0-7-3-13-8-18s-12-8-19-8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/Overview.41a8fa17642fd1ccea87072b54c631de.svg";
export { ForwardRef as ReactComponent };